import { addOrUpdateMessageGroup } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddMessageGroup = () => {
    const entityUpdater = useEntityQueryUpdate();

    const addMessageGroupMutation = useMutation({
        mutationKey: 'add_message_group',
        mutationFn: (model) => {
            const { id = null, ...rest } = model;
            return addOrUpdateMessageGroup(id, rest);
        },
        onSuccess: (data) => {
            entityUpdater(
                [['message_groups'], ['message_group', data.id]],
                data
            );
            notifications.show({
                title: 'Success',
                message: 'Successfully created message group',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return addMessageGroupMutation;
};
export default useAddMessageGroup;
